import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { useSidebarState } from '../hooks/useSidebarState';

export function Layout() {
  const { isCollapsed } = useSidebarState();

  return (
    <div className="flex min-h-screen bg-[#111318]">
      <Sidebar />
      <main 
        className={`
          flex-1 
          transition-all 
          duration-300 
          ${isCollapsed ? 'ml-[60px]' : 'ml-64'}
          w-[calc(100%-${isCollapsed ? '60px' : '256px'})]
        `}
      >
        <Outlet />
      </main>
    </div>
  );
}